import styled from 'styled-components'

import { style } from 'theme'

const Subheading = styled.h4`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  line-height: 1.33;
`

export default Subheading
